<svelte:options tag={null}/>
<script>
	import MediaQuery from "./MediaQuery.svelte";	
	import { BREAKPOINT_SMALLER_THAN_DESKTOP } from './breakpoints';
	let phone_query = `(max-width: ${BREAKPOINT_SMALLER_THAN_DESKTOP})`
</script>

<MediaQuery query={phone_query} let:matches>
	{#if matches}
	<slot />
	{/if}
</MediaQuery>